import Vue from 'vue'
import template from './_products.pug'
import {isRailway} from '../../../lib/travels/operation-type'

const VALIDATION_TYPE_FLAT_RATE = 13
const VALIDATION_TYPE_HOP_ON_HOP_OFF = 14

const SUPPORT_TYPE_DIGITAL = "digital"

export default Vue.extend({
    template: template(),
    props: {
        product: {
        type: Object,
        default: () => ({})
        }
    },
    computed: {
      productDescription(){
        const language = localStorage.getItem('app-language')
        return this.formatProductDescription(language)
      },
      date() {
        if (this.$administrativeAreaTimeZone) {
          const date = moment(this.product.operation_date).tz(this.$administrativeAreaTimeZone)
          return date.format('DD MMM HH:mm').replace('.', '')
        }
        return ''
      },
      hasDestination() {
        return this.product.has_destination
      },
      stopsText() {
        if (this.hasDestination) { return this.stopFromStopToText }
        return this.stopText
      },
      stopFromStopToText() {
        const data = {
          stopFromName: this.product.stop ? this.product.stop.name : '',
          stopToName: this.product.stop_to ? this.product.stop_to.name : ''
        }
        if (Object.values(data).join().trim() === ',') return ''
        return this.$t('travels.stops.originDestination', data)
      },
      stopText() {
        const stopName = this.product.stop ? this.product.stop.name : ''
        return this.$t('travels.stops.onlyOrigin', {stopName})
      },
      travelBusImage() {
        return require('assets/images/ilustrations/private-area/ticket.svg')
      },
      validationTypeBusImage() {
        switch (this.travel.validation_type) {
          case VALIDATION_TYPE_HOP_ON_HOP_OFF:
            return require('assets/images/ilustrations/private-area/blue-bus.svg')
          case VALIDATION_TYPE_PENALTY:
            return require('assets/images/ilustrations/private-area/red-bus.svg')
          case VALIDATION_TYPE_FLAT_RATE:
            return require('assets/images/ilustrations/private-area/ticket.svg')
          default: return ''
        }
      },
      travelTypeName() {
        if(this.product.type == VALIDATION_TYPE_FLAT_RATE){
          return 'flatRate'
        } else {
          return ''
        }
      },
      travelTypeIcon() {
        if(this.product.type == VALIDATION_TYPE_FLAT_RATE){
          return 'ns-icon-ticket text-gray2'
        } else {
          return ''
        }
      },
      suportType() {
        if(this.product.support_entity_type == SUPPORT_TYPE_DIGITAL){
          return '(QR)'
        } else {
          return ''
        }
      },

      isRailway() {
        return isRailway(this.product.tipo_operacion)
      }
    },
    methods: {
        formatProductDescription(language){
          if(!this.product.product_description.es){
            return this.product.product_description
          }else{
            switch (language) {
              case 'es':
                return this.product.product_description.es
              case 'fr':
                return this.product.product_description.fr
              case 'pt':
                return this.product.product_description.pt
              case 'de':
                return this.product.product_description.de
              case 'en':
                return this.product.product_description.en
              default:
                return this.product.product_description
            }
          }
        },

        calculateColor(product) {
          if (product?.route?.color) {
            return `--bg-pill: ${product.route.color}`
          }
          return ''
        },

        tneText(mediaType) {
          if (this.travel.payment_media) {
            return this.travel.payment_media.alias || mediaType
          }

          return this.$t('travels.voidTne')
        }
      }
})